import { createHash, randomBytes } from "node:crypto";

export interface PkceChallenge {
  codeVerifier: string;
  codeChallenge: string;
  codeChallengeMethod: "S256";
}

/**
 * Generates a PKCE code_verifier and S256 code_challenge per RFC 7636.
 * Uses 32 random bytes → 43-char base64url string (within the 43–128 char spec range).
 */
export function generatePkce(): PkceChallenge {
  const codeVerifier = randomBytes(32).toString("base64url");
  const codeChallenge = createHash("sha256")
    .update(codeVerifier)
    .digest("base64url");
  return { codeVerifier, codeChallenge, codeChallengeMethod: "S256" };
}

export function generateState(): string {
  return randomBytes(16).toString("base64url");
}

export interface AuthorizeUrlOptions {
  authorizeEndpoint: string;
  clientId: string;
  redirectUri: string;
  scope: string;
  codeChallenge: string;
  codeChallengeMethod: "S256" | "plain";
  state: string;
}

export function buildAuthorizeUrl(options: AuthorizeUrlOptions): string {
  const url = new URL(options.authorizeEndpoint);
  url.searchParams.set("response_type", "code");
  url.searchParams.set("client_id", options.clientId);
  url.searchParams.set("redirect_uri", options.redirectUri);
  url.searchParams.set("scope", options.scope);
  url.searchParams.set("code_challenge", options.codeChallenge);
  url.searchParams.set("code_challenge_method", options.codeChallengeMethod);
  url.searchParams.set("state", options.state);
  return url.toString();
}
